import React from 'react';
import imageOfCar from '../../resources/bilde_av_bil.png';
import { useConfig } from './default-config';

const Start = ({ onClick }: { onClick: () => void }) => {
    const { texts } = useConfig();
    return (
        <>
            <div className="intro-content">
                <img className="intro-image" alt="bil" src={imageOfCar} />
                <div className="intro-text">
                    <h2 className="h2">{texts.cardHeader}</h2>
                    <p className="intro-info">{texts.introInfo}</p>
                </div>
            </div>
            <div className="intro-button-container">
                <button type="button" className="btn btn-action btn-intro" onClick={onClick}>
                    {texts.buttonStartText}
                </button>
            </div>
        </>
    );
};

export default Start;
